import React, { Component } from 'react';
const products = [{
  name: 'CHMER G32F/S Flushing or Submerged',
  image: 'https://i.machineryhost.com/4a716f7ba05468f225127f29aa2040c5/12dcd33b882b5e3e8fe6c809883ca8d0/large-0000079_chmer-g32f-flushing-type.jpg',
  href: '/listings/4738596-chmer-g32f-s-flushing-or-submerged'
}, {
  name: 'CHMER G43F/S Flushing or Submerged',
  image: 'https://i.machineryhost.com/4a716f7ba05468f225127f29aa2040c5/83a06ca706ea64d68706315fa189866c/large-0000041_chmer-g43f-flushing-type.jpg',
  href: '/listings/4738598-chmer-g43f-s-flushing-or-submerged'
}, {
  name: 'CHMER G53F/S Flushing or Submerged',
  image: 'https://i.machineryhost.com/4a716f7ba05468f225127f29aa2040c5/f290fa8e184d67302deb0f926039923f/large-0000043_chmer-g53f-flushing-type.jpg',
  href: '/listings/4738600-chmer-g53f-s-flushing-or-submerged'
}, {
  name: 'CHMER G64F/S Flushing or Submerged',
  image: 'https://i.machineryhost.com/4a716f7ba05468f225127f29aa2040c5/03c1091af5b28db05dd34323dd9a0250/large-0000045_chmer-g64f-flushing-type.jpg',
  href: '/listings/4738601-chmer-g64f-s-flushing-or-submerged'
}];
export function GSeriesSection() {
  return <section data-id="element-2033">
      <div className="bg-[#1874cd] py-4 px-6 rounded-t-xl" data-id="element-2034">
        <h2 className="text-xl md:text-2xl font-bold text-white" data-id="element-2035">
          CHMER G Series Ball Screw Drive
        </h2>
      </div>
      <div className="bg-white p-6 md:p-8 rounded-b-xl shadow-sm border border-gray-200 border-t-0" data-id="element-2036">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-2037">
          {products.map((product, pIndex) => <div key={pIndex} className="group bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col h-full" data-id="element-2038">
              <a href="/m7_view_item.html" className="bg-gray-50 p-6 h-56 flex items-center justify-center border-b border-gray-100 block" data-id="element-2039">
                <img src={product.image} alt={product.name} className="max-w-full max-h-full object-contain group-hover:scale-105 transition-transform duration-500 block" data-id="element-2040" />
              </a>
              <div className="p-5 flex flex-col flex-grow" data-id="element-2041">
                <a href="/m7_view_item.html" className="no-underline" data-id="element-2042">
                  <h3 className="text-base font-bold text-navy mb-4 leading-tight group-hover:text-orange transition-colors" data-id="element-2043">
                    {product.name}
                  </h3>
                </a>
                <div className="mt-auto pt-4 border-t border-gray-100 flex flex-col space-y-2" data-id="element-2044">
                  <a href={`/ContactPeakMachineSales.html?i515589:default[Product%20Title]=${encodeURIComponent(product.name)}`} className="inline-flex items-center justify-center w-full bg-navy text-white px-4 py-2 rounded-md font-bold text-sm hover:bg-orange transition-colors no-underline" data-id="element-2045">
                    Request for Quote
                  </a>
                  <a href="/m7_view_item.html" className="inline-flex items-center justify-center w-full bg-gray-100 text-navy px-4 py-2 rounded-md font-bold text-sm hover:bg-gray-200 transition-colors no-underline" data-id="element-2046">
                    More Information
                  </a>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}